// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chrome-layout override for AppShell.
   Load AFTER dashboard-redesign.css. Structure changes live in
   AppShell.js (full-width header above an .rf-app-row wrapper, user chip
   in the header, sidebar footer reduced to a version line); this file
   carries the layout shims those changes need. The header and sidebar
   layout comes from dashboard-redesign.css; the header is a brand-gold
   band with a white stretch behind the logo + business name (see
   .rf-topbar below), the sidebar keeps the light palette. */

.rf-app {
  /* surfaces lifted one step so cards read against the page */
  --rf-canvas: #f4f1ea;
  --rf-line: #e2dcd0;
}

/* ---- header spans the full width, above the sidebar ---- */
.rf-app {
  flex-direction: column;
  --rf-header-gold: var(--rf-header);
}
/* Brand-gold band. The white stretch behind the logo + business name is
   painted by .rf-topbar-brand itself (a transparent→white→transparent
   gradient), so it hugs the brand whatever its width and never reaches
   the hamburger or the search box. Everything else on the bar is white. */
.rf-topbar {
  padding: 0 24px;
  position: relative; /* so z-index lifts the hanging logo card over the page */
  z-index: 12; /* above sticky table headers (≤10), below overlays and modals */
  background: var(--rf-header-gold);
  border-bottom-color: var(--rf-header-gold);
  color: #fff;
}
.rf-topbar .rf-clock,
.rf-topbar .rf-clock b {
  color: #fff;
}
.rf-topbar .rf-clock span {
  color: rgba(255, 255, 255, 0.8);
}
.rf-app-row {
  flex-grow: 1;
  min-height: 0;
  display: flex;
}
/* hamburger toggles the sidebar rail (was a chevron on the sidebar edge) */
.rf-hamburger {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  margin-left: -6px;
}
.rf-hamburger:hover {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.5);
}

/* business identity lives in the header, where the page name used to be.
   The logo sits on its own white card; the business name sits on the
   header band in white, like the rest of the bar. */
.rf-topbar-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex-shrink: 0;
  align-self: stretch;
}
.rf-topbar-logo {
  /* a white card flush with the top of the bar, hanging a little below
     it with a shadow — the logo never sits on the brand colour */
  position: relative;
  z-index: 3;
  align-self: flex-start;
  height: calc(100% + 8px);
  margin-bottom: -8px;
  display: inline-flex;
  align-items: center;
  padding: 0 28px;
  margin-left: -6px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(25, 23, 20, 0.22);
}
.rf-topbar-brand img {
  height: var(--rf-logo-h, 36px);
  max-width: 260px;
  object-fit: contain;
  width: auto;
  display: block;
}
.rf-topbar-brand .rf-serif {
  font-size: 26px;
  line-height: 1;
  white-space: nowrap;
  color: #fff;
}
/* stands in for the logo when a business has no artwork */
.rf-topbar-logo .rf-brand-mark {
  height: 34px;
  min-width: 34px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: var(--rf-line);
  color: var(--rf-ink);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

.rf-topbar .rf-clock {
  border-left-color: rgba(255, 255, 255, 0.35);
  border-right: 1px solid rgba(255, 255, 255, 0.35);
  padding-right: 16px;
}

/* the header owns the user chip */
.rf-topbar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.rf-topbar-user img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.rf-tb-user-text {
  min-width: 0;
}
.rf-tb-user-name {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.rf-tb-user-role {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
}
.rf-tb-logout {
  font: 600 11px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #fff;
  cursor: pointer;
  padding: 4px 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  background: transparent;
}
.rf-tb-logout:hover {
  background: rgba(255, 255, 255, 0.16);
  border-color: #fff;
}

/* footer becomes a version line — the user chip moved to the header */
.rf-sidebar-version {
  border-top: 1px solid var(--rf-line);
  padding: 12px 14px;
  font-size: 11px;
  color: var(--rf-muted-2);
  line-height: 1.5;
}

.rf-app.is-collapsed .rf-sidebar-version {
  text-align: center;
}

/* ---- shared utility the redesign pages expect ---- */
.rf-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8b8477;
}

/* Slim header — popped-out work windows (run sheet builder): a thin strip
   with only a small centred logo on a white chip. */
.rf-topbar.is-slim {
  height: 26px;
  padding: 0;
  justify-content: center;
}
.rf-topbar.is-slim img {
  height: 18px;
  width: auto;
  padding: 2px 12px;
  box-sizing: content-box;
  background: #fff;
  border-radius: 3px;
}
.rf-topbar.is-slim .rf-brand-mark {
  height: 18px;
  min-width: 18px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  background: #fff;
  color: var(--rf-ink);
  font-size: 11px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/dark-chrome.css"],"names":[],"mappings":"AAAA;;;;;;;4DAO4D;;AAE5D;EACE,4DAA4D;EAC5D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;;;0EAG0E;AAC1E;EACE,eAAe;EACf,kBAAkB,EAAE,yDAAyD;EAC7E,WAAW,EAAE,gEAAgE;EAC7E,iCAAiC;EACjC,0CAA0C;EAC1C,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;AACA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE;iEAC+D;EAC/D,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;AACA,0DAA0D;AAC1D;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,8DAA8D;EAC9D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;oDACoD;AACpD;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* Chrome-layout override for AppShell.\n   Load AFTER dashboard-redesign.css. Structure changes live in\n   AppShell.js (full-width header above an .rf-app-row wrapper, user chip\n   in the header, sidebar footer reduced to a version line); this file\n   carries the layout shims those changes need. The header and sidebar\n   layout comes from dashboard-redesign.css; the header is a brand-gold\n   band with a white stretch behind the logo + business name (see\n   .rf-topbar below), the sidebar keeps the light palette. */\n\n.rf-app {\n  /* surfaces lifted one step so cards read against the page */\n  --rf-canvas: #f4f1ea;\n  --rf-line: #e2dcd0;\n}\n\n/* ---- header spans the full width, above the sidebar ---- */\n.rf-app {\n  flex-direction: column;\n  --rf-header-gold: var(--rf-header);\n}\n/* Brand-gold band. The white stretch behind the logo + business name is\n   painted by .rf-topbar-brand itself (a transparent→white→transparent\n   gradient), so it hugs the brand whatever its width and never reaches\n   the hamburger or the search box. Everything else on the bar is white. */\n.rf-topbar {\n  padding: 0 24px;\n  position: relative; /* so z-index lifts the hanging logo card over the page */\n  z-index: 12; /* above sticky table headers (≤10), below overlays and modals */\n  background: var(--rf-header-gold);\n  border-bottom-color: var(--rf-header-gold);\n  color: #fff;\n}\n.rf-topbar .rf-clock,\n.rf-topbar .rf-clock b {\n  color: #fff;\n}\n.rf-topbar .rf-clock span {\n  color: rgba(255, 255, 255, 0.8);\n}\n.rf-app-row {\n  flex-grow: 1;\n  min-height: 0;\n  display: flex;\n}\n/* hamburger toggles the sidebar rail (was a chevron on the sidebar edge) */\n.rf-hamburger {\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  margin-left: -6px;\n}\n.rf-hamburger:hover {\n  background: rgba(255, 255, 255, 0.18);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n/* business identity lives in the header, where the page name used to be.\n   The logo sits on its own white card; the business name sits on the\n   header band in white, like the rest of the bar. */\n.rf-topbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  flex-shrink: 0;\n  align-self: stretch;\n}\n.rf-topbar-logo {\n  /* a white card flush with the top of the bar, hanging a little below\n     it with a shadow — the logo never sits on the brand colour */\n  position: relative;\n  z-index: 3;\n  align-self: flex-start;\n  height: calc(100% + 8px);\n  margin-bottom: -8px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 28px;\n  margin-left: -6px;\n  background: #fff;\n  box-shadow: 0 6px 16px rgba(25, 23, 20, 0.22);\n}\n.rf-topbar-brand img {\n  height: var(--rf-logo-h, 36px);\n  max-width: 260px;\n  object-fit: contain;\n  width: auto;\n  display: block;\n}\n.rf-topbar-brand .rf-serif {\n  font-size: 26px;\n  line-height: 1;\n  white-space: nowrap;\n  color: #fff;\n}\n/* stands in for the logo when a business has no artwork */\n.rf-topbar-logo .rf-brand-mark {\n  height: 34px;\n  min-width: 34px;\n  padding: 0 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  background: var(--rf-line);\n  color: var(--rf-ink);\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n}\n\n.rf-topbar .rf-clock {\n  border-left-color: rgba(255, 255, 255, 0.35);\n  border-right: 1px solid rgba(255, 255, 255, 0.35);\n  padding-right: 16px;\n}\n\n/* the header owns the user chip */\n.rf-topbar-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.rf-topbar-user img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.rf-tb-user-text {\n  min-width: 0;\n}\n.rf-tb-user-name {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.rf-tb-user-role {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.8);\n}\n.rf-tb-logout {\n  font: 600 11px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #fff;\n  cursor: pointer;\n  padding: 4px 8px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 6px;\n  background: transparent;\n}\n.rf-tb-logout:hover {\n  background: rgba(255, 255, 255, 0.16);\n  border-color: #fff;\n}\n\n/* footer becomes a version line — the user chip moved to the header */\n.rf-sidebar-version {\n  border-top: 1px solid var(--rf-line);\n  padding: 12px 14px;\n  font-size: 11px;\n  color: var(--rf-muted-2);\n  line-height: 1.5;\n}\n\n.rf-app.is-collapsed .rf-sidebar-version {\n  text-align: center;\n}\n\n/* ---- shared utility the redesign pages expect ---- */\n.rf-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8b8477;\n}\n\n/* Slim header — popped-out work windows (run sheet builder): a thin strip\n   with only a small centred logo on a white chip. */\n.rf-topbar.is-slim {\n  height: 26px;\n  padding: 0;\n  justify-content: center;\n}\n.rf-topbar.is-slim img {\n  height: 18px;\n  width: auto;\n  padding: 2px 12px;\n  box-sizing: content-box;\n  background: #fff;\n  border-radius: 3px;\n}\n.rf-topbar.is-slim .rf-brand-mark {\n  height: 18px;\n  min-width: 18px;\n  padding: 0 6px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 3px;\n  background: #fff;\n  color: var(--rf-ink);\n  font-size: 11px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
